<template>
  <div class="container testimonials">
    <div class="carousel-container">
      <h2>Testimonial</h2>
      <vueper-slides autoplay class="no-shadow">
        <!-- <v-icon slot="pausedIcon" large color="white">pause_circle_outline</v-icon> -->
        <vueper-slide v-for="(slide, i) in slides"
          :key="slide.id"
          :title="slide.title"
          :content="slide.content"></vueper-slide>
      </vueper-slides>
    </div>
    <div class="learn-more">
      <router-link to="/testimonials"><button class="learn-more-btn">Learn More</button></router-link>
    </div>
  </div>
</template>

<script>
  import { VueperSlides, VueperSlide } from 'vueperslides'

  import 'vueperslides/dist/vueperslides.min.css'

  export default {
    components: { VueperSlides, VueperSlide },
    data: () => ({
      slides: [
        {
          id: 'slide-1',
          title: '<h4 class="testing">Guiding her clients on a journey never thought possible.</h4>',
          content: '<p>Jackie has the instinct, intuition, and knowledge necessary to take one to depths that are seemingly beyond reach.<br><span class="name">-Elizabeth Castelluccio </span></p>'
        },
        {
          id: 'slide-2',
          title: '<h4 class="testing">More courage to embrace change.</h4>',
          content: '<p> I have more courage to embrace change, tackle the tougher issues while continuing to look at the bigger picture and move forward making choices that only benefit the direction I am heading in.<br><span class="name">-Allison O’Neill</span></p>'
        },
        {
          id: 'slide-3',
          title: '<h4 class="testing">A safe place of exploration for growth.</h4>',
          content: '<p>Jackie created a safe place of exploration for my personal development and growth, while her thoughtful questions push me to think beyond my current situation and challenge me to believe I can be the best I can be.<br><span class="name">-Jennifer Didine</span></p>'
        }
      ]
    })
  }
</script>

<style>
  @import "https://use.typekit.net/ysf0tri.css";

  .testimonials {
    margin-top: 40px;
    padding: 120px 0 100px;
    background-color: #a2a2a2;
    /*width: 900px;*/
  }

  h4.testing {
    color: #fff;
    font-family: adobe-caslon-pro, serif;
    font-weight: 700;
    font-style: italic;
    line-height: 30px;
  }

  .testimonials .carousel-container {
    border: 10px solid #8d8a8a;
    min-height: 400px;
    margin: 60px auto !important;
    /*overflow: hidden;*/
    width: 60%;
    position: relative;
    z-index: 100;
  }
  .testimonials .carousel-container::before {
    content:url('../assets/img/quote-top.png');
    position: absolute;
    top: 50%;
    left: -25px;
  }
  .testimonials .carousel-container::after {
    content:url('../assets/img/quote-bottom.png');
    position: absolute;
    top: 50%;
    right: -25px;
  }
  
  .testimonials .carousel-container h2 {
    font-size: 28px;
    font-family: lust, serif;
    font-weight: 400;
    font-style: normal;
    color: #fff;
    position: relative;
    top: 30px;
  }

  .vueperslides__arrows { display: none; }
  .testing { 
    color: #fff;
    font-size: 26px;
    font-family: 'Times New Roman', serif;
    font-style: italic;
  }

  .vueperslide__content p {
    color: #fff;
    padding-bottom: 20px;
    font-family: brandon-grotesque, sans-serif;
    font-weight: 400;
    font-style: normal;
  }

  span.name {
    font-family: brandon-grotesque, sans-serif;
    font-weight: 400;
    font-style: normal;
    text-transform: uppercase;
  }

  .vueperslides__bullets {
    bottom: -126px !important;
  }
  .vueperslides__bullets button {
    margin: 0px 5px 20px;
  }

  .vueperslides__bullet {
    border-radius: 0px;
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    margin: 1.5em .6em;
    padding: 0;
    -webkit-transition: .4s ease-in-out;
    -o-transition: .4s ease-in-out;
    transition: .4s ease-in-out;
    width: 12px; 
    height: 6.93px;
    background-color: #f6f6f6;
    margin: 3.46px 0;
    position: relative;
  }
  .vueperslides__bullet--active { 
    border-width: 6px; 
    background-color: #8d8a8a;
    -webkit-transition: .4s ease-in-out;
    -o-transition: .4s ease-in-out;
    transition: .4s ease-in-out;
  }

  .vueperslides__bullet:before,
  .vueperslides__bullet:after {
    content: "";
    position: absolute;
    width: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    -webkit-transition: .4s ease-in-out;
    -o-transition: .4s ease-in-out;
    transition: .4s ease-in-out;
  }

  .vueperslides__bullet:before {
    bottom: 100%;
    border-bottom: 3.46px solid #f6f6f6;
  }

  .vueperslides__bullet:after {
    top: 100%;
    width: 0;
    border-top: 3.46px solid #f6f6f6;
  }

  .vueperslides__bullet--active:before,
  .vueperslides__bullet--active:after {
    content: "";
    position: absolute;
    width: 0;
    border-left: 7.5px solid transparent;
    border-right: 7.5px solid transparent;
    -webkit-transition: .4s ease-in-out;
    -o-transition: .4s ease-in-out;
    transition: .4s ease-in-out;
  }

  .vueperslides__bullet--active:before {
    bottom: 100%;
    border-bottom: 4.33px solid #8d8a8a;
  }

  .vueperslides__bullet--active:after {
    top: 100%;
    width: 0;
    border-top: 4.33px solid #8d8a8a;
  }

  .testimonials button.learn-more-btn {
    border: none;
    margin-top: 60px;
    padding: 15px 35px;
    font-size: 16px;
    border-radius: 5px;
    background-color: #fff;
    color: #4d4d4d;
    cursor: pointer;
    transition: all 0.125s linear; 
    font-family: 'Times New Roman', serif;
    font-style: italic;
  }

  .testimonials button.learn-more-btn:hover { background-color: #ccc; }  

  @media (max-width: 1130px) and (min-width: 975px) {
    .vueperslide { height: 140% !important; }

    h4.testing { margin-bottom: 0; }
    .vueperslides__parallax-wrapper {
      padding-bottom: 46% !important;
    }
  }

  @media (max-width: 750px) {
    .testimonials .no-shadow,
    .testimonials .no-shadow .veuperslides__inner { height: 350px; }
    .testimonials .vueperslides__parallax-wrapper { padding-bottom: 140% !important; }

    .testimonials .carousel-container h2 { margin-top: 10px; }

    .testimonials .vueperslide__content p { padding: 0px 5px; }

    .testimonials .carousel-container::before {
      content:url('../assets/img/quote-top.png');
      position: absolute;
      top: -4%;
      left: 88px;
    }
    .testimonials .carousel-container::after {
      content:url('../assets/img/quote-bottom.png');
      position: absolute;
      top: 100%;
      right: 95px;
    }

    .vueperslide__content-wrapper:not(.vueperslide__content-wrapper--outside-top):not(.vueperslide__content-wrapper--outside-bottom) {
      position: relative;
      width: 100%;
    }

    h4.testing { 
      margin: 70px 0 0 0;
      font-size: 20px;
      line-height: 22px;

    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Testimonials.vue